import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchStatVehicles = async (station_id: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/visits/stations/${station_id}`);
  const stations = await result.json();
  return stations;
};

export default fetchStatVehicles;
